const animationOptions = {
  animateSR: "animation-slide-right",
  animateSL: "animation-slide-left",
  animateSU: "animation-slide-up",
  animateSD: "animation-slide-down",
  animateSLR: "animate-slide-left-rotate",
  leftShell: "animate-left-shell",
  rightShell: "animate-right-shell",
  opacity: "animate-opacity",
};

let throttleTimer = false;

const addObserver = (element, options = {}) => {
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.remove("animate");
        entry.target.classList.add("animate.active");
        entry.target.classList.add(animationOptions[element.ariaLabel]);
        observer.unobserve(entry.target);
      }
    });
  }, options); // Passing the options object to the observer
  observer.observe(element);
};

const items = document.querySelectorAll(".animate");
items.forEach((item) => {
  addObserver(item, { rootMargin: "0px 0px -35% 0px" });
});

const technologyCards = document.querySelectorAll(".technology-card-specs");
technologyCards.forEach((card) => {
  card.addEventListener("mouseenter", () => {
    card.classList.add("technology-card--active");
  });

  card.addEventListener("mouseleave", () => {
    card.classList.remove("technology-card--active");
  });
});

const modelCards = document.querySelectorAll(".model-card");
modelCards.forEach((card) => {
  card.addEventListener("click", () => {
    const designNow = document.getElementById("design-now-btn");
    const designNowUrl = document.getElementById("design-now-url");
    const href = designNowUrl.getAttribute("href");
    const url = `design-customs?model=`;
    const modelHeader = card.querySelector('[aria-label="model"]');
    const model = modelHeader.getAttribute("name");
    const cardHidden = card.querySelector(".card-hidden");
    const cardHiddenOpen =
      document.getElementsByClassName("card-hidden.open")[0];
    if (cardHiddenOpen) {
      const openChevronBtn = cardHiddenOpen.parentNode.querySelector(
        ".chevron-btn--active"
      );
      closeCard(cardHiddenOpen);
      if (openChevronBtn) {
        openChevronBtn.classList.remove("chevron-btn--active");
        openChevronBtn.classList.add("chevron-btn");
      }
      designNow.setAttribute("name", "A6t");
      designNowUrl.setAttribute("href", url + "A6t");
    }
    if (cardHidden) {
      openCard(cardHidden);
      const chevronBtn = card.querySelector(".chevron-btn");
      if (chevronBtn) {
        chevronBtn.classList.remove("chevron-btn");
        chevronBtn.classList.add("chevron-btn--active");
      }
      designNow.setAttribute("name", model);
      designNowUrl.setAttribute("href", url + model);
      return;
    }
  });
});

const sections = document.querySelectorAll(".section-container");
const leftSideNavIndicators = document.querySelectorAll(".side-nav-indicator");
const openCard = (card) => {
  card.style.innerHeight = "1px";
  card.classList.remove("card-hidden");
  card.classList.add("card-hidden.open");
};

const closeCard = (card) => {
  card.classList.remove("card-hidden.open");
  card.classList.add("card-hidden");
};

const updateOpacity = (id, opacity) => {
  const element = document.getElementById(id);
  let initialOpactiy = parseFloat(element.style.opacity);
  initialOpactiy += opacity;
  element.style.opacity = initialOpactiy.toString();
};

const insertElement = (title, parent, ariaLabel) => {
  let customSoundTitle = document.createElement("h3");
  customSoundTitle.classList.add("section-header", "customs-info-header");
  customSoundTitle.ariaLabel = ariaLabel;
  customSoundTitle.classList.add(animationOptions[ariaLabel]);
  customSoundTitle.innerHTML = title;
  parent.append(customSoundTitle);
};

const insertText = (title, parent, ariaLabel) => {
  let text = document.createElement("p");
  text.classList.add("p-light", "py-10", "pdt-40", animationOptions[ariaLabel]);
  text.innerHTML = title;
  parent.append(text);
};

const fadeOutElement = (el, speed) => {
  var seconds = speed / 1000;
  el.style.transition = "opacity " + seconds + "s ease";

  el.style.opacity = 0;
  setTimeout(function () {
    el.parentNode.removeChild(el);
  }, speed);
};

const throttle = (callback, time) => {
  //don't run the function while throttle timer is true
  if (throttleTimer) return;

  //first set throttle timer to true so the function doesn't run
  throttleTimer = true;

  setTimeout(() => {
    //call the callback function in the setTimeout and set the throttle timer to false after the indicated time has passed
    callback();
    throttleTimer = false;
  }, time);
};

const swapImageOnScroll = () => {
  window.addEventListener("scroll", () => {
    const CustomsShapeImage = document.getElementById("custom-shape-image");
    const CustomSoundImage = document.getElementById("custom-sound-image");
    const customsShapeTitle = document.getElementById(
      "custom-shape-title-section"
    );
    const customShapeTextContainer = document.getElementById(
      "custom-shape-text-section"
    );
    let CustomsShapeImageOpacity = CustomsShapeImage.style.opacity;
    let CustomSoundImageOpacity = CustomSoundImage.style.opacity;
    if (CustomsShapeImageOpacity >= 0) {
      updateOpacity("custom-shape-image", -0.03);
      return;
    }
    if (
      CustomsShapeImageOpacity <= 0 &&
      customsShapeTitle.children.length < 2
    ) {
      insertElement("Custom Sound", customsShapeTitle, "animateSL");
      fadeOutElement(customShapeTextContainer.children[0], 100);
      insertText(
        " Nine model variations cover the widest range of sonic requirements.",
        customShapeTextContainer,
        "animateSL"
      );
    }

    if (CustomsShapeImageOpacity <= 0 && CustomSoundImageOpacity > 0) {
      // console.log(customsShapeTitle);
      updateOpacity("custom-sound-image", -0.03);
    }
    // console.log(customsShapeTitle);
    if (CustomSoundImageOpacity <= 0 && customsShapeTitle.children.length < 3) {
      insertElement("Custom Style", customsShapeTitle, "animateSL");
      fadeOutElement(customShapeTextContainer.children[0], 100);
      insertText(
        `With 70+ cosmetic options, per side, there are hundreds of thousands of
         possible combinations giving you the ability to make a truly unique looking CIEM.`,
        customShapeTextContainer,
        "animateSL"
      );
      return;
    }
  });
};

const CustomsShapeImage = document.getElementById("custom-shape-image");
// Event listener for scroll
const isInViewPort = (entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      if (entry.intersectionRect.top) {
        // swapImageOnScroll();
        window.addEventListener("scroll", throttle(swapImageOnScroll, 20));
      }
    }
  });
};

// const sectionContainer = document.getElementById("custom-shape-container");
// const desktopContainer = document.getElementById("desktop-view");
// const customSectionObserver = new IntersectionObserver(isInViewPort, {
//   rootMargin: "0px 0px -10% 0px",
// });
// customSectionObserver.observe(sectionContainer);

var ambasadoreSwwiper = new Swiper(".ambasadors-swiper", {
  // loop: true,
  autoHeight: true,
  updateOnWindowResize: true,
  spaceBetween: 10,
  slideToClickedSlide: true,
  grabCursor: true,
  simulateTouch: true,
  allowTouchMove: true,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  cssMode: true,
  breakpoints: {
    // when window width is >= 320px
    250: {
      slidesPerView: 1.4,
      spaceBetween: 0,
    },
    450: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    570: {
      slidesPerView: 2.5,
      spaceBetween: 0,
    },
    650: {
      slidesPerView: 2.8,
      spaceBetween: 0,
    },
    900: {
      slidesPerView: 1.2,
      autoHeight: true,
      spaceBetween: 10,
    },
    1000: {
      slidesPerView: 1.3,
      spaceBetween: 10,
    },
    // when window width is >= 480px
    1200: {
      slidesPerView: 1.4,
      spaceBetween: 10,
    },
    1400: {
      slidesPerView: 2.3,
      spaceBetween: 10,
    },
    // when window width is >= 640px
    1600: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    1920: {
      slidesPerView: 2.8,
    },
  },
});

var techSwiper = new Swiper(".tech-swiper", {
  autoHeight: true,
  allowTouchMove: true,
  updateOnWindowResize: true,
  spaceBetween: 10,
  slideToClickedSlide: true,
  simulateTouch: true,
  // autoplay: {
  //   delay: 2500,
  // },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  cssMode: true,
});

const scrollToSection = (id) => {
  leftSideNavIndicators.forEach((indicator) => {
    if (indicator.ariaLabel === "id") {
      indicator.classList.add("side-nav-btn-active");
    } else {
      if (indicator.classList.contains("side-nav-btn-active")) {
        indicator.classList.remove("side-nav-btn-active");
      }
    }
  });

  const section = document.getElementById(id);
  window.scrollTo(0, section.offsetTop);
};

const changeTab = (tabIndex) => {
  let tabButtons = document.getElementsByClassName("tab-btn");
  let tabButtonsArray = Array.from(tabButtons);
  tabButtonsArray.forEach((button) => {
    if (button.classList.contains("tab-btn-active")) {
      button.classList.remove("tab-btn-active");
    }
  });
  let currentButton = tabButtonsArray[tabIndex];
  currentButton.classList.add("tab-btn-active");

  let tabs = document.getElementsByClassName("custom-info-tab");
  let tabsArray = Array.from(tabs);
  tabsArray.forEach((tab) => {
    tab.classList.remove("custom-info-tab-active");
  });
  let selectedTab = document.getElementById(`custom-info-tab-${tabIndex + 1}`);

  selectedTab.classList.add("custom-info-tab-active");
};

const options = {
  rootMargin: "0px",
  threshold: 0.35,
};

const sectionObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const sectionId = entry.target.getAttribute("id");

    if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
      leftSideNavIndicators.forEach((indicator) => {
        if (indicator.ariaLabel === sectionId) {
          indicator.classList.add("side-nav-btn-active");
        } else {
          if (indicator.classList.contains("side-nav-btn-active")) {
            indicator.classList.remove("side-nav-btn-active");
          }
        }
      });
    }
  });
}, options);

sections.forEach((section) => {
  sectionObserver.observe(section);
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 950) {
    changeTab(4);
  } else {
    changeTab(0);
  }
});

var lightbox = new PhotoSwipeLightbox({
  gallery: ".ciem-gallery",
  children: "a",
  // dynamic import is not supported in UMD version
  pswpModule: PhotoSwipe,
  spacing: 0.5,
});
lightbox.init();
